var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hasFunnelHeader)?_c('MainNavigation'):_vm._e(),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('QuickQuoteModal'),_vm._v(" "),_c('CongratsModal'),_vm._v(" "),(!_vm.isInPurchaseFunnel && !_vm.hasFunnelHeader)?_c('Footer'):_vm._e(),_vm._v(" "),_c('BuildBadge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }